import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "./SvgIcon.js";
const C = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o("path", { d: "M4.74849 1.7131C3.79338 1.75089 2.91663 2.53012 2.91663 3.57996V16.4201C2.91663 17.8199 4.47611 18.7383 5.70064 18.0599L17.2876 11.6399C18.5473 10.9418 18.5473 9.05827 17.2876 8.36024L5.70064 1.94015C5.39451 1.77056 5.06687 1.70051 4.74849 1.7131Z" }) });
export {
  C as Play
};
//# sourceMappingURL=Play.js.map
